document.addEventListener("DOMContentLoaded", function () {
  // Get the countdown element and extract the data-duration
  const countdownElement = document.querySelector(".vs-countdown-timer");
  const durationStr = countdownElement.dataset.duration;
  let totalSeconds;
  // If there is a countdown element, then proceed
  if (countdownElement) {
    // check if as session total exists
    if (!sessionStorage.getItem("total")) {
      // Now let's convert the duration to HH, MM and SS
      const durationParts = durationStr.split(":");

      const durationHours = parseInt(durationParts[0], 10);
      const durationMinutes = parseInt(durationParts[1], 10);
      const durationSeconds = parseInt(durationParts[2], 10);

      totalSeconds =
        durationHours * 3600 + durationMinutes * 60 + durationSeconds;
    } else {
      totalSeconds = sessionStorage.getItem("total");
    }

    const updateTimer = () => {
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      document.getElementById("countdown-days").textContent = days
        .toString()
        .padStart(2, "0");
      document.getElementById("countdown-hours").textContent = hours
        .toString()
        .padStart(2, "0");
      document.getElementById("countdown-minutes").textContent = minutes
        .toString()
        .padStart(2, "0");
      document.getElementById("countdown-seconds").textContent = seconds
        .toString()
        .padStart(2, "0");

      totalSeconds--;
      sessionStorage.setItem("total", totalSeconds);
    };

    updateTimer();
    setInterval(updateTimer, 1000);
  }
});
